<template>
  <van-popup
    :show="loading"
    :class="['m-loading', `m-loading--${type}`]"
    :duration="0.2"
    :overlay="mask && showBody"
    :close-on-click-overlay="false"
    :teleport="teleport"
  >
    <div :class="['m-loading__body', showBody ? 'm-loading__body--show' : '']">
      <img
        class="m-loading__icon"
        :src="type === 'hourglass' ? HourglassUrl : SpinUrl"
      />
      <div
        v-if="loadText"
        class="m-loading__tip"
      >
        {{ loadText }}
      </div>
    </div>
  </van-popup>
</template>

<script lang="ts" setup>
import HourglassUrl from '@/assets/icons/hourglass.gif'
import SpinUrl from '@/assets/icons/loading.gif'

const props = defineProps({
  loading: { type: Boolean, default: true },
  loadText: { type: String, default: '' },
  type: { type: String as PropType<'spin' | 'hourglass'>, default: 'spin' },
  mask: { type: Boolean, default: true },
  timeout: { type: Number, default: 0 },
  teleport: { type: String, default: '' },
})

const showBody = ref(false)
let showBodyTimer: NodeJS.Timeout | null = null

const clearShowBodyTimer = () => {
  if (!showBodyTimer) return

  clearTimeout(showBodyTimer)
  showBodyTimer = null
}

watch(
  () => props.loading,
  (v) => {
    clearShowBodyTimer()

    const { timeout } = props
    if (v && timeout) {
      showBodyTimer = setTimeout(() => {
        showBody.value = v
      }, timeout)
      return
    }

    if (!v) {
      showBodyTimer = setTimeout(() => {
        showBody.value = v
      }, 200)
      return
    }

    showBody.value = v
  },
  { immediate: true },
)
</script>

<style lang="scss" scoped>
.m-loading {
  background-color: transparent;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transform: translateY(0);
  max-width: none;
  width: 100%;

  &--hourglass {
    .m-loading {
      &__icon {
        width: 4rem;
        height: 4rem;
      }

      &__body {
        flex-direction: column;
      }

      &__tip {
        margin-left: 0;
      }
    }
  }

  &__body {
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    height: 100%;
    transition: opacity 0.2s ease-in-out;

    &--show {
      opacity: 1;
    }
  }

  &__icon {
    width: 2.6rem;
    height: 2.6rem;
  }

  &__tip {
    font-size: 1.6rem;
    line-height: 2rem;
    margin-left: 0.6rem;
    color: $font-white-color;
  }
}
</style>
